import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
    name: 'chat',
    initialState: {
        showChat: false,
        chats: [],
        selectedChat: null
    },
    reducers: {
        setShowChat: (state, action) => {
            state.showChat = action.payload;
        },
        addChat: (state, action) => {
            let exists = state.chats.find(x => x.id === action.payload.id);
            if (!exists)
                state.chats.push(action.payload);
        },
        selectChat: (state, action) => {
            if (action.payload)
                state.selectedChat = state.chats.find(x => x.id === action.payload.id);
            else
                state.selectedChat = null;
        },
        addMessage: (state, action) => {
            let exists = state.chats.find(x => x.id === action.payload.id);
            if (exists) {
                state.chats = state.chats.filter(x => x.id !== action.payload.id);
                exists.messages.push(action.payload);
                state.chats.push(exists);

                if (state.selectedChat != null && state.selectedChat.id === exists.id)
                    state.selectedChat.messages.push(action.payload);
            }
        },
        closeChat: (state, action) => {
            state.chats = state.chats.filter(x => x.id !== action.payload);
            if (state.selectedChat && state.selectedChat.id === action.payload) {
                state.selectedChat = null;
            }
        },

    }
});

export default chatSlice.reducer
export const { setShowChat, addChat, selectChat, addMessage, closeChat } = chatSlice.actions
